import { mapCommonFile } from './CommonFile.mappers';
export const mapArchive = (file, baseFile) => ({
  ...mapCommonFile(file, baseFile),
  mediaType: 'archive',
  width: null,
  height: null
});
export const mapSecureArchive = (file, baseFile) => ({
  ...mapCommonFile(file, baseFile),
  mediaType: 'secure_archive',
  width: null,
  height: null
});
//# sourceMappingURL=Archive.mappers.js.map